export default __webpack_public_path__ + "static/media/open-hand.6e81dad3.svg";